import {
  Directive,
  ElementRef,
  Input,
  OnDestroy,
  OnInit
} from '@angular/core';

import { BoxTogglerService } from '../services/box-toggler.service';

@Directive({
  selector: '[sectionToggle]'
})
export class SectionToggleDirective implements OnInit, OnDestroy {
  @Input('sectionToggle') sectionToggle: string;
  @Input() open: any;

  private clickHandler: ( evt: Event ) => void;

  constructor (
    private el            : ElementRef,
    private boxTogglerApi : BoxTogglerService
  ) {}

  ngOnInit () : void {
    this.clickHandler = ( evt: Event ) => {
      evt.stopPropagation();

      const contentElement = this.boxTogglerApi.getContentElement(this.sectionToggle);

      this.open = !this.open;

      if (this.open) {
        this.boxTogglerApi.open($(this.el.nativeElement), contentElement);
      } else {
        this.boxTogglerApi.close($(this.el.nativeElement), contentElement);
      }
    };

    this.el.nativeElement.addEventListener('click', this.clickHandler);

    if (!this.open) {
      const contentElement = this.boxTogglerApi.getContentElement(this.sectionToggle);

      setTimeout(() => this.boxTogglerApi.close($(this.el.nativeElement), contentElement, true));
    }
  }

  ngOnDestroy () : void {
    this.el.nativeElement.removeEventListener('click', this.clickHandler);
  }
}
